'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import CustomWidgetPropTypes from 'DesignData/propTypes/customWidgets';
import emptyFunction from 'react-utils/emptyFunction';
import { connect } from 'react-redux';
import CodeAccordionItem from 'DesignEditorsUI/components/customWidgetEditor/codePanes/CodeAccordionItem';
import CodeEditorError from 'DesignData/models/validation/CodeEditorError';
import { getUserHasReadAccessOnly } from 'DesignData/selectors/auth';
import * as customWidgetBuffersSelectors from 'DesignData/selectors/customWidgetBuffers';
import * as editorErrorSelectors from 'DesignData/selectors/editorErrors';

const makeMapStateToProps = () => {
  const getSourceErrors = editorErrorSelectors.makeGetSourceErrors();
  const getFieldsContext = customWidgetBuffersSelectors.makeGetFieldsContext();
  const getIsReadOnly = customWidgetBuffersSelectors.makeGetIsReadOnly();
  return (state, ownProps) => {
    return {
      source: customWidgetBuffersSelectors.getCustomWidgetBufferSource(state, ownProps),
      isReadOnly: getUserHasReadAccessOnly(state) || getIsReadOnly(state, ownProps),
      sourceErrors: getSourceErrors(state, ownProps),
      customWidgetContext: getFieldsContext(state, ownProps)
    };
  };
};

class ConnectedHtmlEditor extends Component {
  componentDidMount() {
    this.props.onCodePanesRender();
  }

  render() {
    const {
      sessionId,
      customWidgetId,
      revisionId,
      isReadOnly,
      sourceErrors,
      customWidgetContext,
      onCodeChange,
      onHublValidation,
      onHublValidationFail,
      source
    } = this.props;
    return /*#__PURE__*/_jsx(CodeAccordionItem, {
      sessionId: sessionId,
      asAccordion: false,
      isReadOnly: isReadOnly,
      mode: "hubl-html",
      onCodeChange: onCodeChange,
      onOpenChange: emptyFunction,
      open: true,
      errors: sourceErrors,
      enableHublValidation: true,
      onHublValidation: onHublValidation,
      onHublValidationFail: onHublValidationFail,
      customWidgetContext: customWidgetContext,
      value: source
    }, `${customWidgetId}:${revisionId}`);
  }

}

ConnectedHtmlEditor.propTypes = {
  sessionId: PropTypes.string.isRequired,
  onCodeChange: PropTypes.func.isRequired,
  onHublValidation: PropTypes.func.isRequired,
  onHublValidationFail: PropTypes.func.isRequired,
  customWidgetId: CustomWidgetPropTypes.customWidgetId.isRequired,
  revisionId: PropTypes.number,
  onCodePanesRender: PropTypes.func.isRequired,

  /* Connect */
  isReadOnly: PropTypes.bool.isRequired,
  sourceErrors: PropTypes.arrayOf(PropTypes.instanceOf(CodeEditorError)).isRequired,
  source: PropTypes.string.isRequired,
  customWidgetContext: PropTypes.object.isRequired
};
export default connect(makeMapStateToProps)(ConnectedHtmlEditor);